module.exports = function (input) {
    // Only process numeric values.
    if (isNaN(input) || input === null) {
        return input;
    }
    const s = ['th', 'st', 'nd', 'rd'];
    const v = input % 100;
    return input + (s[(v - 20) % 10] || s[v] || s[0]);
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/oly-ordinal.js
 **/